import AgreementsTable from "./AgreementsTablePage"
import AgreementsEditPageDynamic from "./AgreementsEditPageDynamic.vue"
import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue"

export default {
  path: "/crm",
  component: DashboardLayout,
  children: [{
    path: "Agreements",
    name: "AgreementsTable",
    component: AgreementsTable
  },
  {
    path: "Agreements/:CompanyId/edit",
    name: "AgreementsEdit",
    component: AgreementsEditPageDynamic,
  },
  {
    path: "Agreements/:CompanyId/delete",
    name: "AgreementsDelete",
    component: AgreementsEditPageDynamic,
  },
  {
    path: "Agreements/:CompanyId/show",
    name: "AgreementsShow",
    component: AgreementsEditPageDynamic,
  },
  {
    path: "Agreements/create",
    name: "AgreementsCreate",
    component: AgreementsEditPageDynamic
  },
  ]
}
